<ngx-spinner bdColor="rgba(51,51,51,0.55)"
             size="medium"
             color="#fff"
             type="line-spin-clockwise-fade"
             [fullScreen]="false">
    <p class="loading">{{ 'general.loading' | translate }}...</p>
</ngx-spinner>
<div class="col-12" id="account">
    <div class="col-12">
        <h2 class="page-title" tabindex="0">{{'account.view-receipt' | translate}}</h2>
        <xng-breadcrumb separator=" > ">
            <ng-container *xngBreadcrumbItem="let breadcrumb">
                <span *ngIf="breadcrumb">{{ 'account.' + breadcrumb | translate }}</span>
            </ng-container>
        </xng-breadcrumb>
        <div class="row">
            <div class="col-md-12 col-lg-8 p-2">
                <div class="card border-top">
                    <div class="card-body">
                        <h4>{{'account.view-receipt' | translate}}</h4>
                        <hr class="mt-0">
                        <div class="row pb-2">
                            <div class="col-6 receipt">
                                <strong>{{'receipt.receipt_no' | translate}}:</strong>
                            </div>
                            <div class="col-6 receipt">
                                {{paymentInfo?.id?paymentInfo.id:''}}
                            </div>
                        </div>
                        <div class="row pb-2">
                            <div class="col-6 receipt">
                                <strong>{{'receipt.date_of_payment' | translate}}:</strong>
                            </div>
                            <div class="col-6 receipt pb-1">
                                {{paymentInfo?.transactionDate? functionsService.convertUTCDateToLocalDate(paymentInfo.transactionDate):''}}
                            </div>
                            <div class="col-6 receipt ">
                                <strong>{{'account.period' | translate}}:</strong>
                            </div>
                            <div class="col-6 receipt pb-1">
                                {{paymentInfo?.periodStartDate? functionsService.convertUTCDateToLocalDateOnly(paymentInfo.periodStartDate):''}} - 
                                {{paymentInfo?.periodEndDate? functionsService.convertUTCDateToLocalDateOnly(paymentInfo.periodEndDate):''}}
                            </div>
                            
                        </div>
                        <div class="row pb-2">
                            <div class="col-6 receipt">
                                <strong>{{'account.billing_address' | translate}}:</strong>
                            </div>
                            <div class="col-6 receipt pb-2">
                                {{paymentInfo?.billingAddress1?paymentInfo.billingAddress1+",":''}}
                                {{paymentInfo?.billingAddress2?paymentInfo.billingAddress2+",":''}}
                                {{paymentInfo?.billingCity?paymentInfo.billingCity+",":''}}
                                {{paymentInfo?.billingState?paymentInfo.billingState+",":''}}
                                {{paymentInfo?.billingCountry?paymentInfo.billingCountry+",":''}}
                                {{paymentInfo?.billingZipCode?paymentInfo.billingZipCode:''}}
                                {{paymentInfo?.billingAddress1+paymentInfo?.billingAddress2+paymentInfo?.billingCity+paymentInfo?.billingState+paymentInfo?.billingCountry+paymentInfo?.billingZipCode?'':"N/A"}}
                            </div>
                            <div class="col-6 receipt">
                                <strong>{{'receipt.payment_method' | translate}}:</strong>
                            </div>
                            <div class="col-6 receipt">
                                {{((paymentInfo?.paymentGateway)?((paymentInfo.paymentGateway=="Stripe")?(paymentInfo.cardType + " (" + ('account.ending_in' | translate) + " " + paymentInfo.cardLast4Digits + ")"):paymentInfo.paymentGateway):'') | translate}}
                            </div>
                        </div>
                        <hr class="mt-0">
                        <div class="row">
                            <div class="col-12 mb-2">
                                <strong>{{'receipt.subscribed_to' | translate}}:</strong>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="d-flex flex-row bd-highlight">
                                    <div class="bd-highlight">
                                        <img src="assets/images/sa-icon.png" class="rounded img-display" alt="{{'alt.sa_logo' | translate}}" width="40" height="40"> 
                                    </div>
                                    <div class="p-2 bd-highlight">
                                        <h4>
                                            <span>Panic Alert - {{((paymentInfo?.planName != null)?paymentInfo?.planName:'') | translate}}</span>
                                        </h4>
                                    </div>
                                </div>
                                <hr class="mt-0">
                                <div class="row mb-2">
                                    <div class="col-4">
                                        <strong>{{'account.subscription_id' | translate}}:</strong>
                                    </div>
                                    <div class="col-8">
                                        {{subscription?.key}}
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-4">
                                        <strong>{{'roles.agents_supervisors' | translate}}:</strong>
                                    </div>
                                    <div class="col-8">
                                        {{paymentInfo?.agentsSupervisors}}
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-4">
                                        <strong>{{'roles.users' | translate}}:</strong>
                                    </div>
                                    <div class="col-8">
                                        {{paymentInfo?.users}}
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-4">
                                        <strong>{{'plan.video_feature' | translate}}:</strong>
                                    </div>
                                    <div class="col-8">
                                        {{paymentInfo?.includesVideo ? ('setting.yes' | translate): ('setting.no' | translate)}}
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-4">
                                        <strong>{{'plan.agent_dispatch' | translate}}:</strong>
                                    </div>
                                    <div class="col-8">
                                        {{paymentInfo?.agentDispatch ? ('setting.yes' | translate): ('setting.no' | translate)}}
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-4">
                                        <strong>{{'plan.geo_zone_assignment' | translate}}:</strong>
                                    </div>
                                    <div class="col-8">
                                        {{paymentInfo?.geoAssignment ? ('setting.yes' | translate): ('setting.no' | translate)}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr class="mt-0">
                        <div class="row" *ngIf="paymentInfo?.message && paymentInfo?.message!='Plan upgrade prorate'">
                            <div class="col-6"><strong>{{'account.price' | translate}}: </strong></div>
                            <div class="col-6 text-right">$ {{(paymentInfo?.amount)?(functionsService.currencyFormat(paymentInfo.amount)):'0.00'}} USD</div>
                        </div>
                        <div *ngIf="paymentInfo?.prorate && (paymentInfo?.message && paymentInfo?.message!='Plan upgrade prorate')" class="row">
                            <div class="col-6"><strong>{{'account.proration' | translate}}: </strong></div>
                            <div class="col-6 text-right">- $ {{(paymentInfo?.prorate)?(functionsService.currencyFormat(paymentInfo.prorate)):'0.00'}} USD</div>
                        </div>
                        <div class="row">
                            <div class="col-6"><strong>Subtotal: </strong></div>
                            <div class="col-6 text-right">$ {{(paymentInfo?.subtotal)?(functionsService.currencyFormat(paymentInfo.subtotal)):'0.00'}} USD</div>
                        </div>
                        <div *ngIf="paymentInfo?.tax&&paymentInfo?.tax!=0" class="row">
                            <div class="col-6"><strong>Tax: </strong></div>
                            <div class="col-6 text-right">$ {{(paymentInfo?.tax)?(functionsService.currencyFormat(paymentInfo.tax)):'0.00'}} USD</div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-6"><strong>Total: </strong></div>
                            <div class="col-6 text-right"><h3>$ {{(paymentInfo?.paidAmount)?(functionsService.currencyFormat(paymentInfo.paidAmount)):'0.00'}} USD</h3></div>
                        </div>
                    </div>
                </div>  
            </div>
            <div class="col-md-12 col-lg-4 p-2">
                <div class="card bt-blue">
                    <div class="card-body">
                        <h4>{{'general.actions' | translate}}</h4>
                        <hr class="mt-0">
                        <div class="row">
                            <div class="col-12">
                                <button class="btn btn-blue btn-h-blue w-100" title="{{'receipt.print_to_pdf' | translate}}" 
                                (click)="getPdfReceipt()">{{'receipt.print_to_pdf' | translate}}</button>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
        </div>
    </div>
    <router-outlet></router-outlet>
</div>

<div id="print" class="print bg-white">
    <table width="100%" cellspacing="0" cellpadding="0" style="border-bottom:4pt solid black;padding-left:50px;padding-right:50px;padding-bottom:5px">
      <tr>
        <td>
          <div>
            <img *ngIf="organization?.logo" [src]="organization?.logo" width="60" height="60" alt="Logo" style="border-radius: 50%;"/><br><br>
            <span><strong>{{organization?.name}}</strong></span>
          </div>
        </td>
        <td align="right">
            <img src="https://socialalert3.blob.core.windows.net/photos/email/Email_logo.png" width="100" height="35" alt="{{'alt.sa_logo' | translate}}">
        </td>
      </tr>
    </table>
    <div style="padding-left:50px;padding-right:50px;font-family: sans-serif !important;"><h3>{{'receipt.payment_information' | translate}}</h3></div>
  
    <table width="100%" border="0" cellspacing="0" cellpadding="0" style="background:white;font-family: sans-serif !important;padding-left:50px;padding-right:50px;border-top:1pt solid #C12127;">
      <tr>
          <td>
            <br>
            <span><strong>{{'receipt.receipt_no' | translate}}</strong></span>
          </td>
          <td>
            <br>
            <span>{{paymentInfo?.id?paymentInfo.id:''}}</span>
          </td>
          <td></td>
          <td></td>
      </tr>
      <tr>
        <td>
            <br>
            <strong>{{'receipt.date_of_payment' | translate}}:</strong>
        </td>
        <td>
            <br>
            {{paymentInfo?.transactionDate? functionsService.convertUTCDateToLocalDate(paymentInfo.transactionDate):''}}
        </td>
        <td>
            <br>
            <strong>{{'account.period' | translate}}:</strong>
        </td>
        <td>
            <br>
            {{paymentInfo?.periodStartDate? functionsService.convertUTCDateToLocalDateOnly(paymentInfo.periodStartDate):''}} - 
            {{paymentInfo?.periodEndDate? functionsService.convertUTCDateToLocalDateOnly(paymentInfo.periodEndDate):''}}
        </td>
      </tr>
      <tr>
        <td>
            <br>
            <strong>{{'account.billing_address' | translate}}:</strong><br><br>
        </td>
        <td>
            <br>
            {{paymentInfo?.billingAddress1?paymentInfo.billingAddress1+",":''}}
            {{paymentInfo?.billingAddress2?paymentInfo.billingAddress2+",":''}}
            {{paymentInfo?.billingCity?paymentInfo.billingCity+",":''}}
            {{paymentInfo?.billingState?paymentInfo.billingState+",":''}}
            {{paymentInfo?.billingCountry?paymentInfo.billingCountry+",":''}}
            {{paymentInfo?.billingZipCode?paymentInfo.billingZipCode:''}}
            {{paymentInfo?.billingAddress1+paymentInfo?.billingAddress2+paymentInfo?.billingCity+paymentInfo?.billingState+paymentInfo?.billingCountry+paymentInfo?.billingZipCode?'':"N/A"}}
        </td>
        <td>
            <br>
            <strong>{{'receipt.payment_method' | translate}}:</strong><br><br>
        </td>
        <td>
            <br>
            {{((paymentInfo?.paymentGateway)?((paymentInfo.paymentGateway=="Stripe")?(paymentInfo.cardType + " (" + ('account.ending_in' | translate) + " " + paymentInfo.cardLast4Digits + ")"):paymentInfo.paymentGateway):'') | translate}}
        </td>
      </tr>
    </table>

    <div style="padding-left:50px;padding-right:50px;font-family: sans-serif !important;"><h3>{{'receipt.subscription' | translate}}</h3></div>
    <table width="100%" border="0" cellspacing="0" cellpadding="0" style="background:white;font-family: sans-serif !important;padding-left:50px;padding-right:50px;border-top:1pt solid #C12127;">
      <tr>
          <td>
            <br>
            <strong>Plan:</strong>
          </td>
          <td>
            <br>
            {{((paymentInfo?.planName != null)?paymentInfo?.planName:'') | translate}}
          </td>
          <td></td>
          <td></td>
      </tr>
      <tr>
        <td>
            <br>
            <strong>{{'account.subscription_id' | translate}}:</strong>
        </td>
        <td colspan="2">
            <br>
            {{subscription?.key}}
        </td>
        <td>
        </td>
      </tr>
      <tr>
        <td>
            <br>
            <strong>{{'roles.agents_supervisors' | translate}}:</strong>
        </td>
        <td>
            <br>
            {{paymentInfo?.agentsSupervisors}}
        </td>
      </tr>
      <tr>
        <td>
            <br>
            <strong>{{'roles.users' | translate}}:</strong>
        </td>
        <td>
            <br>
            {{paymentInfo?.users}}
        </td>
      </tr>
      <tr>
        <td>
            <br>
            <strong>{{'plan.video_feature' | translate}}:</strong>
        </td>
        <td>
            <br>
            {{paymentInfo?.includesVideo ? ('setting.yes' | translate): ('setting.no' | translate)}}
        </td>
      </tr>
      <tr>
        <td>
            <br>
            <strong>{{'plan.agent_dispatch' | translate}}:</strong>
        </td>
        <td>
            <br>
            {{paymentInfo?.agentDispatch ? ('setting.yes' | translate): ('setting.no' | translate)}}
        </td>
      </tr>
      <tr>
        <td>
            <br>
            <strong>{{'plan.geo_zone_assignment' | translate}}:</strong>
        </td>
        <td>
            <br>
            {{paymentInfo?.geoAssignment ? ('setting.yes' | translate): ('setting.no' | translate)}}
        </td>
      </tr>
    </table>
    <br>
    <hr class="mt-0">
    <table width="100%" border="0" cellspacing="0" cellpadding="0" style="background:white;font-family: sans-serif !important;padding-left:50px;padding-right:50px;">
        <tr *ngIf="paymentInfo?.message && paymentInfo?.message!='Plan upgrade prorate'">
            <td><br><strong>{{'account.price' | translate}}: </strong></td>
            <td><br>$ {{(paymentInfo?.amount)?(functionsService.currencyFormat(paymentInfo.amount)):'0.00'}} USD</td>
        </tr>
        <tr *ngIf="paymentInfo?.prorate && (paymentInfo?.message && paymentInfo?.message!='Plan upgrade prorate')">
            <td><br><strong>{{'account.proration' | translate}}: </strong></td>
            <td><br>- $ {{(paymentInfo?.prorate)?(functionsService.currencyFormat(paymentInfo.prorate)):'0.00'}} USD</td>
        </tr>
        <tr>
            <td><br><strong>Subtotal: </strong></td>
            <td><br>$ {{(paymentInfo?.subtotal)?(functionsService.currencyFormat(paymentInfo.subtotal)):'0.00'}} USD</td>
        </tr>
        
        <tr *ngIf="paymentInfo?.tax&&paymentInfo?.tax!=0">
            <td><br><strong>Tax: </strong></td>
            <td><br>$ {{(paymentInfo?.tax)?(functionsService.currencyFormat(paymentInfo.tax)):'0.00'}} USD</td>
        </tr>
        <tr>
            <td><br><strong>Total: </strong></td>
            <td><br><h3><strong>$ {{(paymentInfo?.paidAmount)?(functionsService.currencyFormat(paymentInfo.paidAmount)):'0.00'}} USD</strong></h3></td>
        </tr>
    </table>
</div>

	
    
